<template>
  <!--   </v-container>-->
  <v-sheet style="background-color: #fff; height: 100%">
    <v-card elevation="0">
      <v-card-title>
        Artistas
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar artistas"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :footer-props="{ itemsPerPageOptions: [50, 100, 200] }"
        :headers="headers"
        :items="artists"
        :search="search"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn class="ma-5" v-bind="attrs" v-on="on" icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list light dense>
              <v-list-item link @click="youtube_add_video(item)">
                <v-list-item-title small
                  ><v-icon>add</v-icon> YouTube</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <!-- MODAL -->
        <modalmessage ref="modal" />
        <!--/MODAL -->
  </v-sheet>
</template>

<script>
import ArtistService from "../../../app/rest/artist";
import modalmessage from "../../../components/shared/modalmessage";

var artistService = null;

export default {

  components: {
      modalmessage
  },
  data: () => ({
    search: "",
    artists: [],
    headers: [
      { text: "ID", value: "id" },
      {
        text: "Nome artístico",
        align: "left",
        sortable: false,
        value: "name",
      },
      { text: "Nome", value: "fullname" },
      { text: "Tipo", value: "type" },
      { text: "CPF", value: "person_cpf" },
      { text: "Celular", value: "person_cellphone" },
      { text: "Email", value: "person_email" },
      { text: "Data de criação", value: "created_at" },
      { text: "Ação", value: "actions" },
    ],
  }),
  beforeCreate: function () {
    this.$store.dispatch("loading");
    artistService = ArtistService.build();
    artistService
      .get_all()
      .then((e) => {
        if (e.status == "ok") {
          this.artists = e.items.artists.map((item) => {
            if (item.persons.length == 0) {
              return item;
            }
            item.fullname = item.persons[0].name + " " + item.persons[0].lastname;
            item.person_cellphone = item.persons[0].cellphone;
            item.person_cpf = item.persons[0].cpf;
            if (item.persons[0].user == null) {
              return item;
            }
            item.person_email = item.persons[0].user.email;
            return item;
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.$store.dispatch("loading", false);
      });
  },
  methods: {
      youtube_add_video(item){
          this.$refs.modal.show({
                        title: `Deseja adicionar um produto de vídeo para ${item.name}?`,
                        message: `Ao adicionar você precisa notificar o artista que o vídeo está disponível no seu painel. `,
                        btn_1_text: "Adicionar",
                        btn_2_text: "Cancelar",
                        btn_1_action: ()=>{
                            this.liberar_video(item.id);
                        }
                    });
      },
      liberar_video(artist_id){
          this.$store.dispatch("loading");
          artistService.releaseVideo(artist_id).then((e)=>{
              
              this.$store.dispatch("loading", false);
              if(e.status == "ok"){
                this.$refs.modal.show({title:'Video liberado!', message:e.msg, btn_1_text:'OK',btn_1_action: ()=>{}});
              }else{
                  this.$refs.modal.show({title:'Tivemos um problema', message:e.msg, btn_1_text:'OK',btn_1_action: ()=>{}});
              }
          })
      }
  },
};
</script>